import {
  Box,
  Divider,
  Grid2,
  IconButton,
  MenuItem,
  Select,
  Typography,
  InputLabel,
  TextField,
  Paper,
  Checkbox,
  FormControlLabel,
  Button,
  createFilterOptions,
  Autocomplete,
  Dialog,
  DialogContent,
  FormGroup,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { commonCss } from "../../StyleConfig/CommonCss";
import {
  Add,
  ArrowBack,
  ArrowLeft,
  EditOutlined,
  FlashOnRounded,
  Stop,
} from "@mui/icons-material";
import NormalTableWithRadius from "../../Component/NormalTableWithRadius";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import moment from "moment";
import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
// import timezone from "dayjs/plugin/timezone";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosPrivate } from "../../axios/axios";
import {
  api,
  companyInfo,
  infoId,
  riskLevelInfo,
  roleInfo,
  roleNameString,
} from "../API/config";
import { Form, Formik } from "formik";
import Loading from "../../Component/Loading";
import { useSelector } from "react-redux";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import { toast } from "react-toastify";
import ErrorProps from "../../Component/Errorprops";
import Remark from "../../Component/Remark";
import Confirmation from "../../Component/Confirmation";

// dayjs.extend(utc);
// dayjs.extend(timezone);

const PTWForm2 = ({ data, getData, onChangeTab, roleName }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const login = useSelector((state) => state.auth.loginInfo);
  const [confirmIndex, setConfirmIndex] = useState(null);
  const loginRoleId = String(login.roleIds).split(",");
  const [holderName, setHolderName] = useState({
    engineer: data.isEngineerApproved
      ? data?.engineerUser?.firstName + " " + data?.engineerUser?.lastName
      : "",
    om: data.isOperationMangerApproved
      ? data?.operationMangerUser?.firstName +
        " " +
        data?.operationMangerUser?.lastName
      : "",
    hsse: data.isHSSEApproved
      ? data?.hsseVerifierUser?.firstName +
        " " +
        data?.hsseVerifierUser?.lastName
      : "",
    pi: data.isPermitIssuerApproved
      ? data?.permitIssuerUser?.firstName +
        " " +
        data?.permitIssuerUser?.lastName
      : "",
    lpi: data.isLeadPermitIssuerApproved
      ? data?.leadPermitIssuerUser?.firstName +
        " " +
        data?.leadPermitIssuerUser?.lastName
      : "",
    phClose: data.isPHPermitClosed
      ? data?.permitHolderUser?.firstName +
        " " +
        data?.permitHolderUser?.lastName
      : "",
    lpiAndPiClose: data.isLPIPermitClosed
      ? data?.permitClosedByLPIUser?.firstName +
        " " +
        data?.permitClosedByLPIUser?.lastName
      : data.isPIPermitClosed
        ? data?.permitClosedByPIUser?.firstName +
          " " +
          data?.permitClosedByPIUser?.lastName
        : "",
  });
  const [loading, setLoading] = useState(false);
  const [precautionsData, setPrecautionsData] = useState([]);
  const [getPrecaution, setGetPrecaution] = useState({
    precautionSpecified: "",
    roleName: "",
  });

  const [roleAccess, setRoleAccess] = useState({
    adminEngineer:
      (roleName === !roleNameString.admin ||
        (roleName === roleNameString.engineer &&
          data.engineerId === login.userId)) &&
      !data.isEngineerApproved &&
      data.isTechnicianApproved &&
      !data.isCancel === true,
    adminOm:
      (roleName === roleNameString.admin ||
        roleName === roleNameString.operationManager) &&
      !data.isOperationMangerApproved &&
      (data.isEngineerAdviseRequied ? data.isEngineerApproved : true) &&
      !data.isCancel === true,
    engineer:
      roleName === roleNameString.engineer &&
      data.engineerId === login.userId &&
      data.isTechnicianApproved
        ? data.isEngineerApproved || data.isCancel === true
        : true,
    engineerPILPIOM:
      (!(
        roleName === roleNameString.engineer &&
        (data.isEngineerAdviseRequied ? data.engineerId === login.userId : true)
      ) &&
        !(
          roleName === roleNameString.pi &&
          (data.isPermitIssuerApproved
            ? data.permitIssuerId === login.userId
            : true)
        ) &&
        !(
          roleName === roleNameString.lpi &&
          (data.isLeadPermitIssuerApproved
            ? data.leadPermitIssuerId === login.userId
            : true)
        ) &&
        !(roleName === roleNameString.operationManager)) ||
      data.isPIPermitClosed ||
      data.isLPIPermitClosed ||
      data.isCancel === true,
    om:
      roleName === roleNameString.operationManager &&
      (data.isEngineerAdviseRequied ? data.isEngineerApproved : true)
        ? data.isOperationMangerApproved || data.isCancel === true
        : true,
    hsse:
      roleName === roleNameString.HSSE && data.isOperationMangerApproved
        ? data.isHSSEApproved || data.isCancel === true
        : true,
    pi:
      roleName === roleNameString.pi && data.isHSSEApproved
        ? data.isPermitIssuerApproved || data.isCancel === true
        : true,
    lpi:
      roleName === roleNameString.lpi && data.isPermitIssuerApproved
        ? data.isLeadPermitIssuerApproved || data.isCancel === true
        : true,
    phClose: (
      data.riskLevelId === infoId.low
        ? data.isPermitIssuerApproved
        : data.isLeadPermitIssuerApproved
    )
      ? data.isPHPermitClosed ||
        data.isCancel === true ||
        (roleName !== roleNameString.admin &&
          (roleName !== roleNameString.contractStaff ||
            login.userId !== data.permitHolderId))
      : true,
    piAndLpoClose:
      ((roleName === roleNameString.pi &&
        (data.isPermitIssuerApproved
          ? data.permitIssuerId === login.userId
          : false)) ||
        (roleName === roleNameString.lpi &&
          (data.isLeadPermitIssuerApproved
            ? data.leadPermitIssuerId === login.userId
            : false))) &&
      data.isPHPermitClosed
        ? data.isLPIPermitClosed ||
          data.isPIPermitClosed ||
          data.isCancel === true
        : true,
    oeController:(!(roleName === roleNameString.oe) &&
        !(roleName === roleNameString.controller)) ||
      moment().isAfter(
        moment(data.piPermitValidUpTo).format("YYYY-MM-DD"),
        "day",
      ) ||
      data.isPHPermitClosed ||
      data.isCancel === true,
    oeControllerStop:
      (data.riskLevelId === infoId.low
        ? !data.isPermitIssuerApproved
        : !data.isLeadPermitIssuerApproved) ||
      (!(roleName === roleNameString.oe) &&
        !(roleName === roleNameString.controller)) ||
      //  moment().isAfter(moment(data.piPermitValidUpTo).format("YYYY-MM-DD"),"day")||
      data.isPHPermitClosed ||
      data.isCancel === true,
    oeAndController:
      (!(roleName === roleNameString.oe) &&
        !(roleName === roleNameString.controller)) ||
      data.isOEControllerApproved ||
      moment().isAfter(
        moment(data.piPermitValidUpTo).format("YYYY-MM-DD"),
        "day",
      ) ||
      data.isCancel === true ||
      (data.riskLevelId === infoId.low
        ? !data.isPermitIssuerApproved
        : !data.isLeadPermitIssuerApproved),
    displayOEController:
      (roleName === roleNameString.oe ||
        roleName === roleNameString.controller ||
        data.isOEControllerApproved) &&
      (data.riskLevelId === infoId.low
        ? data.isPermitIssuerApproved
        : data.isLeadPermitIssuerApproved),
    isPrecautions:
      roleName === roleNameString.contractStaff
        ? !(
            (data.riskLevelId === infoId.low
              ? data.isPermitIssuerApproved
              : data.isLeadPermitIssuerApproved) &&
            data.isPrecautionPHAcknowledged === false &&
            data.isPHPermitClosed !== true &&
            data.isCancel !== true
          )
        : true,
  });
  const [editPrecaution, setEditPrecaution] = useState({ bol: false, i: null });
  const [PSData, setPSData] = useState([]);
  const [closeRemark, setCloseRemark] = useState({
    PH: data.isPHPermitClosed ? data.phClosedRemarks : "",
    LPIPI: data.isLPIPermitClosed
      ? data.lpiClosedRemarks
      : data.isPIPermitClosed
        ? data.piClosedRemarks
        : "",
  });

  const [reAssign, setAssign] = useState({
    engineer: false,
    om: false,
  });
  const [reAssignData, setReAssignData] = useState({
    engineer: {
      formId: data.id,
      engineerId: null,
    },
    om: {
      formId: data.id,
      operationMangerId: null,
    },
  });
  const [autoCompleteValue, setAutoCompleteValue] = useState({
    engineer: "",
    om: "",
  });
  const [remarkButton, setRemarkButton] = useState(false);

  const [engineerData, setEngineerData] = useState([]);
  const [omData, setOmData] = useState([]);
  const [confirm, setConfirm] = useState({
    reAssign: false,
    approve: false,
    shiftStart: false,
    shiftStop: false,
    close: false,
    precautionDel: false,
  });
  const [confirmValue, setConfirmValue] = useState([]);

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
    getDetails();
  }, []);

  const getDetails = async () => {
    setLoading(true);
    await getAdditionPrecaution();
    await getPermitshiftData();
    //   const getTechnican=api.user.getUserByCompanyIdAndRoleId
    // await axiosPrivate.get(`${getTechnican}?companyId=${companyInfo.ps}&roleId=${roleInfo.engineer}`).then(res=>{
    //   setEngineerData(res.data.data)
    // }).catch(e=>{
    //   setEngineerData([])
    //   console.log(e)
    // })
    if (data.terminalId !== null) {
      handleUserById(data.terminalId);
    }
    setLoading(false);
  };

  const handleUserById = async (terminalId) => {
    const payLoaduserEng = {
      companyId: companyInfo.ps,
      roleId: roleInfo.engineer,
      terminalId: terminalId,
    };
    const payLoaduserOm = {
      companyId: companyInfo.ps,
      roleId: roleInfo.operationManager,
      terminalId: terminalId,
    };
    const getEng = api.user.getFilteredUsers;
    await axiosPrivate
      .post(getEng, payLoaduserEng)
      .then((res) => {
        setEngineerData(res.data.data);
        console.log(res.data.data);
      })
      .catch((e) => {
        setEngineerData([]);
        console.log(e);
      });
    await axiosPrivate
      .post(getEng, payLoaduserOm)
      .then((res) => {
        setOmData(res.data.data);
        console.log(res.data.data);
      })
      .catch((e) => {
        setOmData([]);
        console.log(e);
      });
  };
  const measureList = [
    {
      name: "shutdownOP",
      label: "Shut down system operational",
    },
    {
      name: "fireprotectionOP",
      label: "Fire protection system operational",
    },
    {
      name: "automaticfireprotectionOP",
      label: "Automatic fire protection system operational",
    },
  ];

  const getAdditionPrecaution = async () => {
    const getAddPreLink = api.additionalPrecaution.getByFormId;
    await axiosPrivate
      .get(`${getAddPreLink}?formId=${atob(searchParams.get("id"))}`)
      .then((res) => {
        const filteredData = res.data.data.filter((item) => !item.isDeleted);
        setPrecautionsData(filteredData);
        console.log("precation", filteredData);
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setPrecautionsData([]);

        console.log(e);
      });
  };

  const initialValue = {
    ...data,
    operationalMeasures: {
      ...data?.operationalMeasures,
      formId: data.id,
      shutdownOP: data?.operationalMeasures?.shutdownOP,
      fireprotectionOP: data?.operationalMeasures?.fireprotectionOP,
      automaticfireprotectionOP:
        data?.operationalMeasures?.automaticfireprotectionOP,
      otherMeasures: data?.operationalMeasures?.otherMeasures,
    },
    piPermitValidFrom:
      data.piPermitValidFrom !== null
        ? data.piPermitValidFrom
        : data.actualPermitValidFrom,
    piPermitValidUpTo:
      data.piPermitValidUpTo !== null
        ? data.piPermitValidUpTo
        : data.actualPermitValidUpTo,
    lpiPermitValidFrom: data.isLeadPermitIssuerApproved
      ? data.lpiPermitValidFrom
      : data.piPermitValidFrom,
    lpiPermitValidUpTo: data.isLeadPermitIssuerApproved
      ? data.lpiPermitValidUpTo
      : data.piPermitValidUpTo,
  };

  const onAcknowledge = (value) => {
    const pi = roleName === roleNameString.pi && !data.isPermitIssuerApproved;
    const aprovalFormLink = api.PTWForm.saveApproval;
    const appData = {
      id: data.id,
      isApproved: true,
      verifierId: login.userId,
      validFrom: pi ? value.piPermitValidFrom : value.lpiPermitValidFrom,
      validUpTo: pi ? value.piPermitValidUpTo : value.lpiPermitValidUpTo,
    };
    console.log(appData);
    axiosPrivate
      .post(`${aprovalFormLink}?roleName=${roleName}`, appData)
      .then((res) => {
        setConfirm({ ...confirm, approve: false });
        setConfirmValue([]);
        navigate(`/formlist/${btoa(roleName)}`);
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, approve: false });
        setConfirmValue([]);
        console.log(e);
      });
  };

  const onSubmit = (value) => {
    setConfirm({ ...confirm, approve: true });
    setConfirmValue([value]);
  };
  const rejectApproval = async (remark) => {
    const aprovalFormLink = api.PTWForm.saveApproval;
    const appData = {
      id: data.id,
      amended:
        roleName === roleNameString.engineer ||
        roleName === roleNameString.operationManager,
      isApproved: false,
      verifierId: login.userId,
      remarks: remark,
    };
    console.log(appData);
    await axiosPrivate
      .post(`${aprovalFormLink}?roleName=${roleName}`, appData)
      .then((res) => {
        navigate(`/formlist/${btoa(roleName)}`);
        setRemarkButton(false);
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        console.log(e);
      });
  };
  const handleReassign = async (type) => {
    const reassignLink = api.PTWForm.reAssign;
    console.log(reAssignData.technician);
    await axiosPrivate
      .post(`${reassignLink}`, reAssignData[type])
      .then((res) => {
        toast.success("Successfully Reassigned");
        setAutoCompleteValue({ ...autoCompleteValue, [type]: "" });
        setAssign({ ...reAssign, [type]: false });
        setConfirm({ ...confirm, reAssign: false });
        setConfirmValue([]);
        navigate(`/formlist/${btoa(roleName)}`);
      })
      .catch((e) => {
        console.log(e);
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, reAssign: false });
        setConfirmValue([]);
      });
  };

  const handlePrecautionAcknowledge = async () => {
    const precautionIds = precautionsData
      .filter((item) => item.isAcknowledged !== true)
      .map((item) => item.id);
    if (precautionIds.length === 0) {
      toast.error("All precautions are already approved");
      return;
    }
    const acknowledgeLink = api.additionalPrecaution.acknowledge;
    const payload = {
      formId: atob(searchParams.get("id")),
      precautionIds,
    };
    await axiosPrivate
      .put(acknowledgeLink, payload)
      .then((res) => {
        toast.success("Successfully Acknowledged");
        getData();
      })
      .catch((e) => {
        console.log(e);
        toast.error(e.response.data.message);
      });
  };

  const handleDeletePrecaution = (id) => {
    const deletePrecaution = api.additionalPrecaution.delete;
    axiosPrivate
      .delete(`${deletePrecaution}/${id}`)
      .then(() => {
        toast.success("Successfully Deleted");
        setConfirm({ ...confirm, precautionDel: false });
        setConfirmValue([]);
        getAdditionPrecaution();
      })
      .catch((e) => {
        console.error(e);
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, precautionDel: false });
        setConfirmValue([]);
      });
  };

  const precautionsColumn = [
    {
      Header: "Precautions",
      accessor: "precautionSpecified",
    },
    {
      Header: "Role",
      accessor: "roleName",
    },
    {
      Header: "User",
      accessor: "addedByUserDetail",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: "inherit",
            }}
          >
            {cell.value.firstName + " " + cell.value.lastName}
          </Typography>
        );
      },
    },
    {
      Header: "Acknowledged At",
      accessor: "acknowledgedAt",
      Cell: ({ cell }) => {
        return cell.value
          ? moment(cell.value).format("DD/MM/YYYY HH:mm")
          : "---";
      },
    },
    {
      accessor: "id",
      Cell: ({ cell }) => {
        return (
          <Box
            sx={{
              whiteSpace: "nowrap",
              display: "flex",
              justifyContent: "center",
              width: "100%",
              alignItems: "center",
            }}
          >
            <IconButton
              disabled={roleAccess.engineerPILPIOM}
              onClick={() => {
                setEditPrecaution({ bol: true, i: cell.row.original.id });
                setGetPrecaution(cell.row.original);
              }}
            >
              <EditOutlined sx={{ color: commonCss.blue }} />
            </IconButton>

            {/* {confirmIndex === cell.row.index ? (
                                         
                              
                                         <Box
                                             sx={{
                                                 display: 'flex',
                                                 justifyContent: 'flex-end',
                                                 alignItems: 'center',
                                                 gap: 1, 
                                             }}
                                         >
                                             <ErrorProps>Are you sure wants to delete</ErrorProps>
                                             <Button
                                                 onClick={() => handleDeletePrecaution(cell.row.original.id)}
                                             sx={{
                                                 color: commonCss.red, 
                                                 borderColor: commonCss.red, }}
                                                 size="small"
                                                 variant="outlined"
                                             >
                                                 Yes
                                             </Button>
                                             <Button
                                                 onClick={() => setConfirmIndex(null)}
                                                 sx={{
                                                   color: "rgb(0, 86, 151)", 
                                                   borderColor: "rgb(0, 86, 151)", }}
                                                 size="small"
                                                 variant="outlined"
                                             >
                                                 No
                                             </Button>
                                         </Box>

                                 ) : ( */}

            <IconButton
              disabled={roleAccess.engineerPILPIOM}
              onClick={() => {
                setConfirm({ ...confirm, precautionDel: true });
                setConfirmValue([cell.row.original.id]);
              }}
            >
              <DeleteOutlined sx={{ color: commonCss.red }} />
            </IconButton>
            {/* )} */}
          </Box>
        );
      },
    },
  ];
  const shiftColumns = [
    // {
    //   Header: "Date",
    //   accessor: "date",
    // },
    // {
    //   Header: "Start Shift",
    //   accessor: "shiftStartDateTime",
    //   // Cell: ({ cell }) => (
    //   //   <Typography
    //   //     sx={{
    //   //       fontSize: "inherit",
    //   //       fontWeight: "inherit",
    //   //       color: "inherit",
    //   //     }}
    //   //   >
    //   //     {cell.value !== null ? moment(cell.value).format("hh:mm a") : null}
    //   //   </Typography>
    //   // ),
    // },
    {
      Header: "Start Shift",
      accessor: "shiftStartDateTime",
      Cell: ({ cell }) => (
        <Typography
          sx={{
            fontSize: "inherit",
            fontWeight: "inherit",
            color: "inherit",
          }}
        >
          {cell.value !== null
            ? moment(cell.value).format("YYYY-MM-DD hh:mm a") // Format to "hh:mm a"
            : "Not Found"}{" "}
          {/* Fallback text if value is null */}
        </Typography>
      ),
    },

    {
      Header: "Permit Holder",
      accessor: "permitHolderUserDetails", // Use accessor for raw data
      Cell: ({ cell }) => {
        const { firstName, lastName } =
          cell.row.original.permitHolderUserDetails || {};
        return `${firstName || ""} ${lastName || ""}`.trim();
      },
    },
    {
      Header: "OE/Controller",
      accessor: "startShiftOEControllerUserDetails", // Use accessor for raw data
      Cell: ({ cell }) => {
        const { firstName, lastName } =
          cell.row.original.startShiftOEControllerUserDetails || {};
        return `${firstName || ""} ${lastName || ""}`.trim();
      },
    },
    // {
    //   Header: "End Shift",
    //   accessor: "shiftEndDateTime",
    //   // Cell: ({ cell }) => (
    //   //   <Typography
    //   //     sx={{
    //   //       fontSize: "inherit",
    //   //       fontWeight: "inherit",
    //   //       color: "inherit",
    //   //     }}
    //   //   >
    //   //     {cell.value !== null ? moment(cell.value).format("hh:mm a") : null}
    //   //   </Typography>
    //   // ),
    // },
    {
      Header: "End Shift",
      accessor: "shiftEndDateTime",
      Cell: ({ cell }) => (
        <Typography
          sx={{
            fontSize: "inherit",
            fontWeight: "inherit",
            color: "inherit",
          }}
        >
          {cell.value ? moment(cell.value).format("YYYY-MM-DD hh:mm a") : null}
        </Typography>
      ),
    },
    {
      Header: "OE/Controller",
      accessor: "endShiftOEControllerUserDetails",
      Cell: ({ cell }) => {
        const { firstName, lastName } =
          cell.row.original.endShiftOEControllerUserDetails || {};
        return `${firstName || ""} ${lastName || ""}`.trim();
      },
    },
    {
      accessor: "id",
      Cell: ({ cell }) => (
        <Box
          sx={{
            whiteSpace: "nowrap",
            display: "flex",
            justifyContent: "center",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Button
            disabled={
              cell.row.original.shiftEndDateTime !== null ||
              roleAccess.oeControllerStop
            }
            onClick={() => {
              setConfirm({ ...confirm, shiftStop: true });
              setConfirmValue([
                data,
                "shiftEndDateTime",
                cell.row.original.id,
                cell.row.original.shiftStartDateTime,
                cell.row.original.permitHolderApprovedAt,
                cell.row.original.oeControllerId,
              ]);
            }}
            sx={{
              color:
                cell.row.original.shiftEndDateTime !== null
                  ? "default"
                  : commonCss.red,
            }}
          >
            Stop
          </Button>
        </Box>
      ),
    },
  ];

  const handlePrecaution = async () => {
    if (editPrecaution.bol) {
      const putData = {
        formId: data.id,
        addedBy: login.userId,
        ...getPrecaution,
      };
      let updatePrecaution = api.additionalPrecaution.edit;
      await axiosPrivate
        .put(`${updatePrecaution}/${editPrecaution.i}`, putData)
        .then((res) => {
          getAdditionPrecaution();
          setEditPrecaution({ bol: false, i: null });
          setGetPrecaution({
            precautionSpecified: "",
            roleName: "",
          });
        })
        .catch((e) => {
          toast.error(e.response.data.message);
          console.log(e);
        });
    } else {
      let addPrecaution = api.additionalPrecaution.add;
      const postData = {
        formId: data.id,
        addedBy: login.userId,
        ...getPrecaution,
      };
      await axiosPrivate
        .post(`${addPrecaution}`, postData)
        .then((res) => {
          getAdditionPrecaution();
          setEditPrecaution({ bol: false, i: null });
          setGetPrecaution({
            precautionSpecified: "",
            roleName: "",
          });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  // const handleShift = async (
  //   type,
  //   id,
  //   shiftStartDateTime,
  //   permitHolderApprovedAt
  // ) => {
  //   if (type === "shiftEndDateTime") {
  //     console.log("Ending Shift...");
  //     console.log("mypayloadupdate", payloadUpdate);
  //     let payloadUpdate = [...shiftData];
  //     const shiftData = {
  //       shiftEndDateTime: moment().toISOString(),
  //       isShiftClosed: true,
  //       formId: searchParams.get("id"),
  //       oeControllerId: login.userId,
  //       shiftStartDateTime,
  //       permitHolderApprovedAt,
  //       id,
  //     };
  //     setShiftData(payloadUpdate);
  //   } else {
  //     console.log("Starting Shift...");
  //     const newShift = {
  //       date: moment().format("YYYY-MM-DD"),
  //       start: moment().format(""),
  //       startPH: "Permit Holder",
  //       startOE: "OE",
  //       end: null,
  //       endPH: "",
  //       endOE: "",
  //     };

  //     setShiftData([...shiftData, newShift]);

  //     const updatesps = api.PTWPermitShift.edidt;

  //     setLoading(true);
  //     await axiosPrivate
  //       .put(`${updatesps}/${id}`, shiftData) // Use PUT and pass the ID
  //       .then((response) => {
  //         console.log("Shift ended successfully:", response.data);
  //         getPermitshiftData(); // Refresh the data
  //       })
  //       .catch((e) => {
  //         console.error("Error ending shift:", e);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //     const payload = {
  //       formId: searchParams.get("id"),
  //       shiftStartDateTime: moment().toISOString(),
  //       permitHolderApprovedAt: moment().toISOString(),
  //       shiftEndDateTime: null,
  //       oeControllerId: login.userId,
  //       oeControllerApprovedAt: moment().toISOString(),
  //       isShiftClosed: false,
  //     };
  //     console.log("mypayload", payload);
  //     setLoading(true);
  //     let permiteshift = api.PTWPermitShift.addd;
  //     await axiosPrivate
  //       .post(`${permiteshift}`, payload)
  //       .then((response) => {
  //         console.log(response.data);
  //         getPermitshiftData();
  //       })
  //       .catch((e) => {
  //         console.error(e);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   }
  // };
  const handleShift = async (
    value,
    type,
    id,
    shiftStartDateTime,
    permitHolderApprovedAt,
    oeControllerId,
  ) => {
    if (!data.isOEControllerApproved) {
      const saveFormLink = api.PTWForm.saveForm;

      console.log(value);
      await axiosPrivate
        .post(`${saveFormLink}`, value)
        .then((res) => {
          console.log(res);
          const aprovalFormLink = api.PTWForm.saveApproval;
          const appData = {
            id: data.id,
            isApproved: true,
            verifierId: login.userId,
          };
          console.log(appData);
          axiosPrivate
            .post(`${aprovalFormLink}?roleName=${roleName}`, appData)
            .then((res) => {
              if (type === "shiftEndDateTime") {
                console.log("Ending Shift...");

                const payloadUpdate = {
                  shiftEndDateTime: moment(),
                  isShiftClosed: true,
                  formId: atob(searchParams.get("id")),
                  endShiftOEControllerId: login.userId,
                  endShiftOEControllerApprovedAt: moment(),
                  isShiftClosed: true,
                  shiftStartDateTime,
                  permitHolderApprovedAt,
                  oeControllerId,
                  id,
                };

                console.log("mypayloadupdate", payloadUpdate);
                const updatesps = api.PTWPermitShift.edit;
                axiosPrivate
                  .put(`${updatesps}/${id}`, payloadUpdate)
                  .then((response) => {
                    console.log("Shift ended successfully:", response.data);
                    setConfirm({ ...confirm, shiftStop: false });
                    setConfirmValue([]);
                    getPermitshiftData();
                  })
                  .catch((e) => {
                    toast.error(e.response.data.message);
                    setConfirm({ ...confirm, shiftStop: false });
                    setConfirmValue([]);
                    console.error("Error ending shift:", e);
                  });
              } else if (type === "start") {
                const payload = {
                  formId: atob(searchParams.get("id")),
                  shiftStartDateTime: moment(),
                  permitHolderApprovedAt: moment(),
                  shiftEndDateTime: null,
                  oeControllerId: login.userId,
                  oeControllerApprovedAt: moment(),
                  isShiftClosed: false,
                };

                console.log("mypayload", payload);
                let permiteshift = api.PTWPermitShift.add;
                axiosPrivate
                  .post(`${permiteshift}`, payload)
                  .then((response) => {
                    console.log(response.data);
                    setConfirm({ ...confirm, shiftStart: false });
                    setConfirmValue([]);
                    getPermitshiftData();
                    getData();
                  })
                  .catch((e) => {
                    toast.error(e.response.data.message);
                    console.error(e);
                    setConfirm({ ...confirm, shiftStart: false });
                    setConfirmValue([]);
                  });
              }
            })
            .catch((e) => {
              toast.error(e.response.data.message);
              console.log(e);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      if (type === "shiftEndDateTime") {
        console.log("Ending Shift...");

        const payloadUpdate = {
          shiftEndDateTime: moment(),
          isShiftClosed: true,
          formId: atob(searchParams.get("id")),
          endShiftOEControllerId: login.userId,
          endShiftOEControllerApprovedAt: moment(),
          isShiftClosed: true,
          shiftStartDateTime,
          permitHolderApprovedAt,
          oeControllerId,
          id,
        };

        console.log("mypayloadupdate", payloadUpdate);
        const updatesps = api.PTWPermitShift.edit;
        axiosPrivate
          .put(`${updatesps}/${id}`, payloadUpdate)
          .then((response) => {
            console.log("Shift ended successfully:", response.data);
            setConfirm({ ...confirm, shiftStop: false });
            setConfirmValue([]);
            getPermitshiftData();
          })
          .catch((e) => {
            toast.error(e.response.data.message);
            setConfirm({ ...confirm, shiftStop: false });
            setConfirmValue([]);
            console.error("Error ending shift:", e);
          });
      } else if (type === "start") {
        const payload = {
          formId: atob(searchParams.get("id")),
          shiftStartDateTime: moment(),
          permitHolderApprovedAt: moment(),
          shiftEndDateTime: null,
          oeControllerId: login.userId,
          oeControllerApprovedAt: moment(),
          isShiftClosed: false,
        };

        console.log("mypayload", payload);
        let permiteshift = api.PTWPermitShift.add;
        axiosPrivate
          .post(`${permiteshift}`, payload)
          .then((response) => {
            setConfirm({ ...confirm, shiftStart: false });
            setConfirmValue([]);
            console.log(response.data);
            getPermitshiftData();
          })
          .catch((e) => {
            toast.error(e.response.data.message);
            setConfirm({ ...confirm, shiftStart: false });
            setConfirmValue([]);
            console.error(e);
          });
      }
    }
  };

  const getPermitshiftData = async () => {
    // setLoading(true);
    const getpsdata = api.PTWPermitShift.getByFormId;
    await axiosPrivate
      .get(`${getpsdata}?formId=${atob(searchParams.get("id"))}`)
      .then((res) => {
        const formattedData = res.data.data.map((item) => ({
          ...item,
          date: moment(item.date).format("YYYY-MM-DD"),
        }));
        setPSData(formattedData);
        console.log("PSData", formattedData);
      })
      .catch((e) => {
        setPSData([]);
        toast.error(e.response.data.message);
        console.error(e);
      });
    //setLoading(false);
  };

  const handlePermitClose = async () => {
    const permitCloseLink = api.PTWForm.permitClose;
    const postData = {
      id: data.id,
      verifierId: login.userId,
      remarks: data.isPHPermitClosed ? closeRemark.LPIPI : closeRemark.PH,
      isApproved: true,
      isClosed: true,
    };
    console.log(postData);
    const filterPsData = PSData.filter((fil) => fil.isShiftClosed === false);
    // if(filterPsData.length===0){
    await axiosPrivate
      .post(`${permitCloseLink}?roleName=${roleName}`, postData)
      .then((res) => {
        toast.success("Permit Closed");
        setConfirm({ ...confirm, close: false });
        setConfirmValue([]);
        navigate(`/formlist/${btoa(roleName)}`);
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, close: false });
        setConfirmValue([]);
        console.log(e);
      });
    // }else{
    //   toast.error("Please Stop Shift")
    // }
  };
  return (
    <>
      {loading ? (
        <Loading color={commonCss.blue} />
      ) : (
        <Formik
          initialValues={initialValue}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ handleChange, setFieldValue, values, resetForm }) => (
            <Form>
              <Grid2 container spacing={"0.6rem"}>
                <Grid2 container size={12} spacing={"1rem"}>
                  <Grid2 size={12}>
                    <Typography
                      variant="body2"
                      fontWeight={commonCss.mainLabelHeading}
                      color={commonCss.blue}
                    >
                      Precautions for the work (in addition to those overleaf,
                      and stated in associated certificates)
                    </Typography>
                  </Grid2>
                  <Grid2
                    container
                    size={12}
                    alignItems={"center"}
                    spacing={"1rem"}
                  >
                    <Grid2 size={{ xs: 12, md: 6 }}>
                      <InputLabel sx={{ pl: 0.5 }}>
                        <Typography
                          variant="body2"
                          fontWeight="500"
                          color="black"
                        >
                          Specify additional precautions
                        </Typography>
                      </InputLabel>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={getPrecaution.precautionSpecified}
                        slotProps={{
                          input: {
                            readOnly: roleAccess.engineerPILPIOM,
                          },
                        }}
                        onChange={(e) => {
                          setGetPrecaution({
                            ...getPrecaution,
                            precautionSpecified: e.target.value,
                          });
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: roleAccess.engineerPILPIOM
                              ? commonCss.readOnlyBGColor
                              : commonCss.inputBackgroundColor,
                            borderRadius: commonCss.inputBorderRadius,
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: commonCss.inputBorderColor,
                          },
                        }}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 5 }}>
                      <InputLabel sx={{ pl: 0.5 }}>
                        <Typography
                          variant="body2"
                          fontWeight="500"
                          color="black"
                        >
                          Engineer/Operation Manager/PI/LPI
                        </Typography>
                      </InputLabel>
                      <Select
                        size="small"
                        value={getPrecaution.roleName}
                        readOnly={roleAccess.engineerPILPIOM}
                        onChange={(e) => {
                          setGetPrecaution({
                            ...getPrecaution,
                            roleName: e.target.value,
                          });
                        }}
                        sx={{
                          backgroundColor: roleAccess.engineerPILPIOM
                            ? commonCss.readOnlyBGColor
                            : commonCss.inputBackgroundColor,
                          borderRadius: commonCss.inputBorderRadius,

                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: commonCss.inputBorderColor,
                          },
                        }}
                        fullWidth
                      >
                        <MenuItem value="Engineer">Engineer</MenuItem>
                        <MenuItem value="Operation Manager">
                          {" "}
                          Operation Manager
                        </MenuItem>
                        <MenuItem value="PI"> PI</MenuItem>
                        <MenuItem value="LPI">LPI</MenuItem>
                      </Select>
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 1 }}>
                      <IconButton
                        disabled={roleAccess.engineerPILPIOM}
                        sx={{
                          border: `3px solid ${commonCss.blue}`,
                          p: 0,
                          mt: 1.5,
                        }}
                        onClick={handlePrecaution}
                      >
                        <Add sx={{ color: commonCss.blue }} />
                      </IconButton>
                    </Grid2>

                    <Grid2
                      size={{ xs: 8 }}
                      sx={{
                        display:
                          precautionsData.length === 0 ? "none" : "default",
                      }}
                    >
                      <Paper sx={{ background: "transparent" }}>
                        <NormalTableWithRadius
                          data={precautionsData}
                          columns={precautionsColumn}
                        />
                        <Grid2
                          container
                          justifyContent={"flex-end"}
                          size={{ xs: 12, md: 12 }}
                          sx={{
                            display: roleAccess.isPrecautions
                              ? "none"
                              : "default",
                            mt: "1rem",
                          }}
                        >
                          <Button
                            variant="contained"
                            type="button"
                            onClick={handlePrecautionAcknowledge}
                            sx={{
                              backgroundColor: commonCss.blue,
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "15vw",
                            }}
                          >
                            Acknowledge
                          </Button>
                        </Grid2>
                      </Paper>
                    </Grid2>
                    <Grid2 size={12}>
                      <Typography
                        variant="body2"
                        fontWeight={commonCss.normalSentenceWeight}
                        color={commonCss.normalSenternceColor}
                        sx={{ textTransform: "none", lineHeight: 1.5 }}
                      >
                        I certify that I have fully considered the implications
                        of the work in line with the responsibilities detailed
                        in the permit to work procedure and that the above
                        precautions are adequate for the work to be carried out
                        provided that the precautions are established and
                        maintained.
                      </Typography>
                    </Grid2>

                    <Grid2
                      container
                      size={{ xs: 12 }}
                      alignItems={"flex-end"}
                      spacing={"1rem"}
                      sx={{
                        display: values.isEngineerAdviseRequied
                          ? "default"
                          : "none",
                      }}
                    >
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <InputLabel sx={{ pl: 0.5 }}>
                          <Typography
                            variant="body2"
                            fontWeight="500"
                            color="black"
                          >
                            Engineer Name
                          </Typography>
                        </InputLabel>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={holderName.engineer}
                          slotProps={{
                            input: {
                              readOnly: true,
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: commonCss.readOnlyBGColor,
                              borderRadius: commonCss.inputBorderRadius,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <InputLabel sx={{ pl: commonCss.labelPadding }}>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Date and Time
                          </Typography>
                        </InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                            <DateTimePicker
                              ampm={false}
                              format="DD/MM/YYYY HH:mm"
                              value={
                                values.isEngineerApproved
                                  ? dayjs(values.engineerApprovedAt)
                                  : null
                              }
                              viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                                seconds: renderTimeViewClock,
                              }}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  variant: "outlined",
                                },
                              }}
                              readOnly
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: commonCss.readOnlyBGColor,
                                  borderRadius: commonCss.inputBorderRadius,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: commonCss.inputBorderColor,
                                },
                              }}
                              fullWidth
                            />
                          </DemoItem>
                        </LocalizationProvider>
                      </Grid2>
                      {/* <Grid2 size={{xs:12,md:4}} sx={{display:roleAccess.engineer?"none":"default"}}> */}
                      <Grid2
                        size={{ xs: 12, md: 4 }}
                        sx={{
                          display: roleAccess.adminEngineer
                            ? "default"
                            : "none",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "0.6rem",
                          }}
                        >
                          {/* <Button
                        
                        variant="contained"
                        sx={{
                          backgroundColor: commonCss.blue,
                          borderRadius: commonCss.buttonBorderRadius,
                          textTransform: "none",
                          padding: "0.6rem 1rem",
                          color: commonCss.buttonTextColor,
                          width: "15vw",
                          display:roleAccess.adminEngineer?"default":"none"
                        }}
                        onClick={() => {
                          setAssign({...reAssign,engineer:true})
                        }}
                      >
                        Reassign
                      </Button> */}
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: commonCss.red,
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "10vw",
                            }}
                            onClick={() => {
                              setRemarkButton(true);
                            }}
                          >
                            Amend
                          </Button>
                          <Button
                            variant="contained"
                            type="submit"
                            sx={{
                              backgroundColor: commonCss.green,
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "10vw",
                              // height: "6vh",
                            }}
                          >
                            Acknowledge
                          </Button>
                        </Box>
                      </Grid2>
                    </Grid2>

                    <Grid2
                      container
                      size={{ xs: 12 }}
                      alignItems={"flex-end"}
                      spacing={"1rem"}
                      sx={{ display: reAssign.om ? "none" : "default" }}
                    >
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <InputLabel sx={{ pl: 0.5 }}>
                          <Typography
                            variant="body2"
                            fontWeight="500"
                            color="black"
                          >
                            Operation Manager
                          </Typography>
                        </InputLabel>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={holderName.om}
                          slotProps={{
                            input: {
                              readOnly: true,
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: commonCss.readOnlyBGColor,
                              borderRadius: commonCss.inputBorderRadius,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <InputLabel sx={{ pl: commonCss.labelPadding }}>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Date and Time
                          </Typography>
                        </InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                            <DateTimePicker
                              ampm={false}
                              format="DD/MM/YYYY HH:mm"
                              value={
                                values.isOperationMangerApproved
                                  ? dayjs(values.operationMangerApprovedAt)
                                  : null
                              }
                              viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                                seconds: renderTimeViewClock,
                              }}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  variant: "outlined",
                                },
                              }}
                              readOnly
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: commonCss.readOnlyBGColor,
                                  borderRadius: commonCss.inputBorderRadius,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: commonCss.inputBorderColor,
                                },
                              }}
                              fullWidth
                            />
                          </DemoItem>
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2
                        size={{ xs: 12, md: 4 }}
                        sx={{ display: roleAccess.om ? "none" : "default" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "0.6rem",
                            alignItems: "flex-end",
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: commonCss.red,
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "10vw",
                            }}
                            onClick={() => {
                              setRemarkButton(true);
                            }}
                          >
                            Amend
                          </Button>

                          {/* <Button
                        
                        variant="contained"
                        sx={{
                          backgroundColor: commonCss.blue,
                          borderRadius: commonCss.buttonBorderRadius,
                          textTransform: "none",
                          padding: "0.6rem 1rem",
                          color: commonCss.buttonTextColor,
                          width: "15vw",
                          display:roleAccess.adminOm?"default":"none"
                        }}
                        onClick={() => {
                          setAssign({...reAssign,om:true})
                        }}
                      >
                        Reassign
                      </Button> */}
                          <Button
                            variant="contained"
                            type="submit"
                            sx={{
                              backgroundColor: commonCss.green,
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "10vw",
                              // height: "6vh",
                            }}
                          >
                            Acknowledge
                          </Button>
                        </Box>
                      </Grid2>
                    </Grid2>
                    {/* <Grid2 container size={12} sx={{display:reAssign.om?'default':"none"}}>
          <Grid2 size={{xs:12,md:4}}>
          <Autocomplete
                  readOnly={!roleAccess.adminOm}
                  name="engineerId"
                  inputValue={autoCompleteValue.om}
                  filterOptions={filterOptions}
                  loading={omData.length === 0 }
                  options={omData}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.firstName+" "+option.lastName || option}
                  onChange={(event, value) => {
                    if (value) {
                      setReAssignData({...reAssignData,om:{...reAssignData.om,operationMangerId:value.id}})
                      setAutoCompleteValue({...autoCompleteValue,om:value.firstName+" "+value.lastName});
                    } else {
                      setReAssignData({...reAssignData,om:{...reAssignData.om,operationMangerId:null}})
                      setAutoCompleteValue({...autoCompleteValue,om:""});
                    }
                  }}
                  // onInputChange={(e, v) => {
                  //   setAgt({...agt,agtCom:v});
                  // }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="operationMangerId"
                      size="small"
                      // variant="standard"
                      
                      onChange={(e)=>{setAutoCompleteValue({...autoCompleteValue,om:e.target.value})}}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: !roleAccess.adminOm?commonCss.readOnlyBGColor:commonCss.inputBackgroundColor,
                          borderRadius:  commonCss.inputBorderRadius,
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: commonCss.inputBorderColor,
                        },
                      }}
                      
                    />
                  )}
                />
          </Grid2>
          <Grid2 size={{xs:12,md:4}}>
            <Box sx={{display:"flex",gap:"0.6rem",alignItems:"center"}}>
            <Button
            variant="contained"
             sx={{
               backgroundColor: commonCss.red,
               borderRadius: commonCss.buttonBorderRadius,
               textTransform: "none",
               padding: "0.6rem 1rem",
               color: commonCss.buttonTextColor,
               width: "15vw",
             }}
             onClick={() => {
               setAssign({...reAssign,om:false})
               setAutoCompleteValue({...autoCompleteValue,om:""})
               setReAssignData({...reAssignData,om:{formId:data.id,operationMangerId:null}})
             }}
           >
             Cancel
             </Button>
             <Button
                        
                          variant="contained"
                          sx={{
                            backgroundColor: commonCss.green,
                            borderRadius: commonCss.buttonBorderRadius,
                            textTransform: "none",
                            padding: "0.6rem 1rem",
                            color: commonCss.buttonTextColor,
                            width: "15vw",
                          }}
                          onClick={() => {
                            setConfirm({...confirm,shiftStart:true})
                            setConfirmValue(["om"])
                          }}
                        >
                          Submit
              </Button>
            </Box>
          
          </Grid2>
         
        </Grid2> */}
                  </Grid2>
                </Grid2>
                <Grid2 container size={12} spacing={"1rem"}>
                  <Grid2 size={12}>
                    <Typography
                      variant="body2"
                      fontWeight={commonCss.mainLabelHeading}
                      color={commonCss.blue}
                    >
                      Permit Authorized By
                    </Typography>
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Grid2 container size={12} spacing={"0.5rem"}>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.mainLabelHeading}
                          color="rgb(0, 86, 151)"
                        >
                          HSSE VERIFIER
                        </Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.normalSentenceWeight}
                          color={commonCss.normalSenternceColor}
                          sx={{ textTransform: "none" }}
                        >
                          Verified all the HSSE requirement in place including
                          JMS and JSA
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Grid2 container size={12} spacing={"0.5rem"}>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.mainLabelHeading}
                          color="rgb(0, 86, 151)"
                        >
                          PERMIT ISSUER (PI)
                        </Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.normalSentenceWeight}
                          color={commonCss.normalSenternceColor}
                          sx={{ textTransform: "none" }}
                        >
                          Authorised for execution without additional
                          certificates
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Grid2
                      container
                      size={12}
                      spacing={"0.5rem"}
                      sx={{
                        display:
                          data.riskLevelId === riskLevelInfo.low
                            ? "none"
                            : "default",
                      }}
                    >
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.mainLabelHeading}
                          color="rgb(0, 86, 151)"
                        >
                          LEAD PERMIT ISSUER (LPI)
                        </Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.normalSentenceWeight}
                          color={commonCss.normalSenternceColor}
                          sx={{ textTransform: "none" }}
                        >
                          Authorised for execution only in accordance with
                          attached certificate
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Grid2>

                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Box sx={{ width: "100%" }}>
                      <Grid2 container size={12} spacing={"0.5rem"}>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Name
                            </Typography>
                          </InputLabel>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            value={holderName.hsse}
                            slotProps={{
                              input: {
                                readOnly: true,
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: commonCss.readOnlyBGColor,
                                borderRadius: commonCss.inputBorderRadius,
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: commonCss.inputBorderColor,
                              },
                            }}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Date/Time
                            </Typography>
                          </InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DateTimePicker
                                ampm={false}
                                format="DD/MM/YYYY HH:mm"
                                viewRenderers={{
                                  hours: renderTimeViewClock,
                                  minutes: renderTimeViewClock,
                                  seconds: renderTimeViewClock,
                                }}
                                value={
                                  values.isHSSEApproved
                                    ? dayjs(values.hsseVerifierApprovedAt)
                                    : null
                                }
                                readOnly
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    variant: "outlined",
                                  },
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: commonCss.inputBorderRadius,
                                    backgroundColor: commonCss.readOnlyBGColor,
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: commonCss.inputBorderColor,
                                  },
                                }}
                                fullWidth
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid2>
                        <Grid2
                          size={{ xs: 12 }}
                          sx={{ display: roleAccess.hsse ? "none" : "default" }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: commonCss.red,
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "15vw",
                            }}
                            onClick={() => {
                              setRemarkButton(true);
                            }}
                          >
                            Reject
                          </Button>
                        </Grid2>
                        <Grid2
                          size={{ xs: 12 }}
                          sx={{ display: roleAccess.hsse ? "none" : "default" }}
                        >
                          <Button
                            variant="contained"
                            type="submit"
                            sx={{
                              backgroundColor: commonCss.green,
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "15vw",
                              // height: "6vh",
                            }}
                          >
                            Approve
                          </Button>
                        </Grid2>
                      </Grid2>
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Box sx={{ width: "100%" }}>
                      <Grid2 container size={12} spacing={"0.5rem"}>
                        <Grid2 container size={12}>
                          <Grid2 size={{ xs: 12 }}>
                            <InputLabel>
                              <Typography
                                variant="body2"
                                fontWeight={commonCss.labelFontWeight}
                                color={commonCss.labelInputColor}
                              >
                                Name
                              </Typography>
                            </InputLabel>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={holderName.pi}
                              slotProps={{
                                input: {
                                  readOnly: true,
                                },
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: commonCss.readOnlyBGColor,
                                  borderRadius: commonCss.inputBorderRadius,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: commonCss.inputBorderColor,
                                },
                              }}
                            />
                          </Grid2>
                          <Grid2 size={{ xs: 12 }}>
                            <InputLabel>
                              <Typography
                                variant="body2"
                                fontWeight={commonCss.labelFontWeight}
                                color={commonCss.labelInputColor}
                              >
                                Date/Time
                              </Typography>
                            </InputLabel>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.isPermitIssuerApproved
                                      ? dayjs(values.permitIssuerApprovedAt)
                                      : null
                                  }
                                  readOnly
                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      variant: "outlined",
                                    },
                                  }}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: commonCss.inputBorderRadius,
                                      backgroundColor:
                                        commonCss.readOnlyBGColor,
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: commonCss.inputBorderColor,
                                    },
                                  }}
                                  fullWidth
                                />
                              </DemoItem>
                            </LocalizationProvider>
                          </Grid2>
                          <Grid2 size={{ xs: 12 }}>
                            <InputLabel>
                              <Typography
                                variant="body2"
                                fontWeight={commonCss.labelFontWeight}
                                color={commonCss.labelInputColor}
                              >
                                From
                              </Typography>
                            </InputLabel>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DatePicker
                                  ampm={false}
                                  format="DD/MM/YYYY"
                                  value={
                                    values.piPermitValidFrom !== null
                                      ? dayjs(values.piPermitValidFrom)
                                      : null
                                  }
                                  readOnly={roleAccess.pi}
                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      variant: "outlined",
                                    },
                                  }}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: commonCss.inputBorderRadius,
                                      backgroundColor: roleAccess.pi
                                        ? commonCss.readOnlyBGColor
                                        : commonCss.inputBackgroundColor,
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: commonCss.inputBorderColor,
                                    },
                                  }}
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        // const dateFrom = moment(
                                        //   newValue.$d
                                        // ).format("YYYY-MM-DD");

                                        // const hour =
                                        //   new Date().getHours() < 10
                                        //     ? "0" + new Date().getHours()
                                        //     : new Date().getHours();
                                        // const min =
                                        //   new Date().getMinutes() < 10
                                        //     ? "0" + new Date().getMinutes()
                                        //     : new Date().getMinutes();
                                        // const sec =
                                        //   new Date().getSeconds() < 10
                                        //     ? "0" + new Date().getSeconds()
                                        //     : new Date().getSeconds();
                                        // const dateFormat =
                                        //   dateFrom +
                                        //   "T" +
                                        //   hour +
                                        //   ":" +
                                        //   min +
                                        //   ":" +
                                        //   sec +
                                        //   "Z";
                                        // .format(
                                        //   "YYYY-MM-DDTHH:mm:ss"
                                        // );
                                        const dateFrom =
                                          moment(newValue.$d).format(
                                            "YYYY-MM-DD",
                                          ) + "T00:00:00Z";
                                        console.log(dateFrom);
                                        setFieldValue(
                                          "piPermitValidFrom",
                                          dateFrom,
                                        );

                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        // setFieldValue("installationDate", dateFormat);
                                      }
                                    }
                                  }}
                                  fullWidth
                                />
                              </DemoItem>
                            </LocalizationProvider>
                          </Grid2>
                          <Grid2 size={{ xs: 12 }}>
                            <InputLabel>
                              <Typography
                                variant="body2"
                                fontWeight={commonCss.labelFontWeight}
                                color={commonCss.labelInputColor}
                              >
                                Until
                              </Typography>
                            </InputLabel>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DatePicker
                                  ampm={false}
                                  format="DD/MM/YYYY"
                                  value={
                                    values.piPermitValidUpTo !== null
                                      ? dayjs(values.piPermitValidUpTo)
                                      : null
                                  }
                                  readOnly={roleAccess.pi}
                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      variant: "outlined",
                                    },
                                  }}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: commonCss.inputBorderRadius,
                                      backgroundColor: roleAccess.pi
                                        ? commonCss.readOnlyBGColor
                                        : commonCss.inputBackgroundColor,
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: commonCss.inputBorderColor,
                                    },
                                  }}
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        // const dateFrom = moment(
                                        //   newValue.$d
                                        // ).format("YYYY-MM-DD");

                                        // const hour =
                                        //   new Date().getHours() < 10
                                        //     ? "0" + new Date().getHours()
                                        //     : new Date().getHours();
                                        // const min =
                                        //   new Date().getMinutes() < 10
                                        //     ? "0" + new Date().getMinutes()
                                        //     : new Date().getMinutes();
                                        // const sec =
                                        //   new Date().getSeconds() < 10
                                        //     ? "0" + new Date().getSeconds()
                                        //     : new Date().getSeconds();
                                        // const dateFormat =
                                        //   dateFrom +
                                        //   "T" +
                                        //   hour +
                                        //   ":" +
                                        //   min +
                                        //   ":" +
                                        //   sec +
                                        //   "Z";
                                        // .format(
                                        //   "YYYY-MM-DDTHH:mm:ss"
                                        // );
                                        const dateFrom =
                                          moment(newValue.$d).format(
                                            "YYYY-MM-DD",
                                          ) + "T00:00:00Z";
                                        console.log(dateFrom);
                                        setFieldValue(
                                          "piPermitValidUpTo",
                                          dateFrom,
                                        );

                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        // setFieldValue("installationDate", dateFormat);
                                      }
                                    }
                                  }}
                                  fullWidth
                                />
                              </DemoItem>
                            </LocalizationProvider>
                          </Grid2>
                          <Grid2
                            size={{ xs: 12 }}
                            sx={{ display: roleAccess.pi ? "none" : "default" }}
                          >
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: commonCss.red,
                                borderRadius: commonCss.buttonBorderRadius,
                                textTransform: "none",
                                padding: "0.6rem 1rem",
                                color: commonCss.buttonTextColor,
                                width: "15vw",
                              }}
                              onClick={() => {
                                setRemarkButton(true);
                              }}
                            >
                              Reject
                            </Button>
                          </Grid2>
                          <Grid2
                            size={{ xs: 12 }}
                            sx={{ display: roleAccess.pi ? "none" : "default" }}
                          >
                            <Button
                              variant="contained"
                              type="submit"
                              sx={{
                                backgroundColor: commonCss.green,
                                borderRadius: commonCss.buttonBorderRadius,
                                textTransform: "none",
                                padding: "0.6rem 1rem",
                                color: commonCss.buttonTextColor,
                                width: "15vw",
                                // height: "6vh",
                              }}
                            >
                              Approve
                            </Button>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Box sx={{ width: "100%" }}>
                      <Grid2
                        container
                        size={12}
                        spacing={"0.5rem"}
                        sx={{
                          display:
                            data.riskLevelId === riskLevelInfo.low
                              ? "none"
                              : "default",
                        }}
                      >
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Name
                            </Typography>
                          </InputLabel>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            value={holderName.lpi}
                            slotProps={{
                              input: {
                                readOnly: true,
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: commonCss.readOnlyBGColor,
                                borderRadius: commonCss.inputBorderRadius,
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: commonCss.inputBorderColor,
                              },
                            }}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Date/Time
                            </Typography>
                          </InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DateTimePicker
                                ampm={false}
                                format="DD/MM/YYYY HH:mm"
                                viewRenderers={{
                                  hours: renderTimeViewClock,
                                  minutes: renderTimeViewClock,
                                  seconds: renderTimeViewClock,
                                }}
                                readOnly
                                value={
                                  values.isLeadPermitIssuerApproved
                                    ? dayjs(values.leadPermitIssuerApprovedAt)
                                    : null
                                }
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    variant: "outlined",
                                  },
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: commonCss.inputBorderRadius,
                                    backgroundColor: commonCss.readOnlyBGColor,
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: commonCss.inputBorderColor,
                                  },
                                }}
                                fullWidth
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              From
                            </Typography>
                          </InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DatePicker
                                ampm={false}
                                format="DD/MM/YYYY"
                                value={
                                  values.lpiPermitValidFrom !== null
                                    ? dayjs(values.lpiPermitValidFrom)
                                    : null
                                }
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    variant: "outlined",
                                  },
                                }}
                                readOnly={roleAccess.lpi}
                                onChange={(newValue) => {
                                  console.log(newValue);
                                  if (newValue !== null) {
                                    if (`${newValue.$d}` !== "Invalid Date") {
                                      // const dateFrom = moment(
                                      //   newValue.$d
                                      // ).format("YYYY-MM-DD");

                                      // const hour =
                                      //   new Date().getHours() < 10
                                      //     ? "0" + new Date().getHours()
                                      //     : new Date().getHours();
                                      // const min =
                                      //   new Date().getMinutes() < 10
                                      //     ? "0" + new Date().getMinutes()
                                      //     : new Date().getMinutes();
                                      // const sec =
                                      //   new Date().getSeconds() < 10
                                      //     ? "0" + new Date().getSeconds()
                                      //     : new Date().getSeconds();
                                      // const dateFormat =
                                      //   dateFrom +
                                      //   "T" +
                                      //   hour +
                                      //   ":" +
                                      //   min +
                                      //   ":" +
                                      //   sec +
                                      //   "Z";
                                      const dateFrom =
                                        moment(newValue.$d).format(
                                          "YYYY-MM-DD",
                                        ) + "T00:00:00Z";
                                      console.log(dateFrom);
                                      setFieldValue(
                                        "lpiPermitValidFrom",
                                        dateFrom,
                                      );

                                      // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                      // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                      // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                      // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                      // setFieldValue("installationDate", dateFormat);
                                    }
                                  }
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: commonCss.inputBorderRadius,
                                    backgroundColor: roleAccess.lpi
                                      ? commonCss.readOnlyBGColor
                                      : commonCss.inputBackgroundColor,
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: commonCss.inputBorderColor,
                                  },
                                }}
                                fullWidth
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Until
                            </Typography>
                          </InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DatePicker
                                ampm={false}
                                format="DD/MM/YYYY"
                                readOnly={roleAccess.lpi}
                                minDate={dayjs(data.piPermitValidFrom)}
                                maxDate={dayjs(data.piPermitValidUpTo)}
                                value={
                                  values.lpiPermitValidUpTo !== null
                                    ? dayjs(values.lpiPermitValidUpTo)
                                    : null
                                }
                                onChange={(newValue) => {
                                  console.log(newValue);
                                  if (newValue !== null) {
                                    if (`${newValue.$d}` !== "Invalid Date") {
                                      // const dateFrom = moment(
                                      //   newValue.$d
                                      // ).format("YYYY-MM-DD");

                                      // const hour =
                                      //   new Date().getHours() < 10
                                      //     ? "0" + new Date().getHours()
                                      //     : new Date().getHours();
                                      // const min =
                                      //   new Date().getMinutes() < 10
                                      //     ? "0" + new Date().getMinutes()
                                      //     : new Date().getMinutes();
                                      // const sec =
                                      //   new Date().getSeconds() < 10
                                      //     ? "0" + new Date().getSeconds()
                                      //     : new Date().getSeconds();
                                      // const dateFormat =
                                      //   dateFrom +
                                      //   "T" +
                                      //   hour +
                                      //   ":" +
                                      //   min +
                                      //   ":" +
                                      //   sec +
                                      //   "Z";
                                      const dateFrom =
                                        moment(newValue.$d).format(
                                          "YYYY-MM-DD",
                                        ) + "T00:00:00Z";
                                      console.log(dateFrom);
                                      setFieldValue(
                                        "lpiPermitValidUpTo",
                                        dateFrom,
                                      );

                                      // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                      // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                      // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                      // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                      // setFieldValue("installationDate", dateFormat);
                                    }
                                  }
                                }}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    variant: "outlined",
                                  },
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: commonCss.inputBorderRadius,
                                    backgroundColor: roleAccess.lpi
                                      ? commonCss.readOnlyBGColor
                                      : commonCss.inputBackgroundColor,
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: commonCss.inputBorderColor,
                                  },
                                }}
                                fullWidth
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid2>
                        <Grid2
                          size={{ xs: 12 }}
                          sx={{ display: roleAccess.lpi ? "none" : "default" }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: commonCss.red,
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "15vw",
                            }}
                            onClick={() => {
                              setRemarkButton(true);
                            }}
                          >
                            Reject
                          </Button>
                        </Grid2>
                        <Grid2
                          size={{ xs: 12 }}
                          sx={{ display: roleAccess.lpi ? "none" : "default" }}
                        >
                          <Button
                            variant="contained"
                            type="submit"
                            sx={{
                              backgroundColor: commonCss.green,
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "15vw",
                              // height: "6vh",
                            }}
                          >
                            Approve
                          </Button>
                        </Grid2>
                      </Grid2>
                    </Box>
                  </Grid2>
                </Grid2>
                <Grid2
                  container
                  size={12}
                  spacing={"0.5rem"}
                  sx={{
                    display: roleAccess.displayOEController
                      ? "default"
                      : "none",
                  }}
                >
                  <Grid2 size={12}>
                    <Typography
                      variant="body2"
                      fontWeight={commonCss.mainLabelHeading}
                      color={commonCss.blue}
                    >
                      Operational Measures: To be signed by Operation Executive
                      (for MPP) or Controller (for KVDT)
                    </Typography>
                  </Grid2>
                  <Grid2 size={{ xs: 12 }}>
                    <FormGroup>
                      {measureList.map((typeLevel, i) => (
                        <FormControlLabel
                          key={i}
                          sx={{
                            "& .MuiFormControlLabel-label.Mui-disabled": {
                              color: "black",
                            },
                          }}
                          control={
                            <Checkbox
                              disabled={roleAccess.oeAndController}
                              name={typeLevel.name}
                              checked={
                                values.operationalMeasures[typeLevel.name]
                              }
                              onChange={(e) => {
                                setFieldValue(
                                  `operationalMeasures.${typeLevel.name}`,
                                  e.target.checked,
                                );
                              }}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  color: "rgb(0, 86, 151)",
                                },
                                "&:checked": {
                                  color: "rgb(0, 86, 151)",
                                },
                              }}
                              //  onChange={(e)=>{

                              //   if(typeLevel.label==="Others"&&e.target.checked){
                              //     setWorkAreaOthers(true)
                              //   }else{
                              //     setWorkAreaOthers(false)
                              //   }
                              //  }}
                            />
                          }
                          label={typeLevel.label}
                        />
                      ))}
                    </FormGroup>
                  </Grid2>
                  <Grid2 size={12}>
                    <InputLabel>
                      <Typography
                        variant="body2"
                        fontWeight={commonCss.labelFontWeight}
                        color={commonCss.labelInputColor}
                      >
                        Any Other Measure
                      </Typography>
                    </InputLabel>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      multiline
                      rows={2}
                      name="operationalMeasures.otherMeasures"
                      value={values.operationalMeasures.otherMeasures}
                      onChange={handleChange}
                      slotProps={{
                        input: {
                          readOnly: roleAccess.oeAndController,
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: roleAccess.oeAndController
                            ? commonCss.readOnlyBGColor
                            : commonCss.inputBackgroundColor,
                          borderRadius: "13px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "747373",
                        },
                      }}
                    />
                  </Grid2>
                  {/* <Grid2 container size={12}>
        <Grid2 size={{xs:12,md:4}} >
            <InputLabel sx={{pl:commonCss.labelPadding}}>
              <Typography variant="body2" fontWeight={commonCss.labelFontWeight} color={commonCss.labelInputColor}>
                Name
              </Typography>
            </InputLabel>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              value={holderName.oeControllerName}
              slotProps={{
                input:{
                  readOnly:true
                }
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: roleAccess.oeAndController?commonCss.readOnlyBGColor: commonCss.inputBackgroundColor, 
                  borderRadius:commonCss.inputBorderRadius
                },
                '& .MuiOutlinedInput-notchedOutline': {
                 borderColor: commonCss.inputBorderColor, 
                },
              }}
              
            />
          </Grid2>
         
          <Grid2 size={{xs:12,md:4}}>
            <InputLabel sx={{pl:commonCss.labelPadding}}>
              <Typography variant="body2" fontWeight={commonCss.labelFontWeight} color={commonCss.labelInputColor}>
                Date and Time
              </Typography>
            </InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoItem>
                <DateTimePicker
                  ampm={false}
                  format="DD/MM/YYYY HH:mm"
                  value={data.isOEControllerApproved?dayjs(dayjs(data.oeControllerApprovedAt)):null}
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                  readOnly={true}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: roleAccess.oeAndController?commonCss.readOnlyBGColor:commonCss.inputBackgroundColor, 
                      borderRadius:commonCss.inputBorderRadius
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                     borderColor: commonCss.inputBorderColor, 
                    },
                  }}
                  fullWidth
                />
              </DemoItem>
            </LocalizationProvider>
          </Grid2>
          
        </Grid2> */}
                </Grid2>
                <Grid2 container size={12} spacing={"1rem"}>
                  <Grid2 size={12}>
                    <Typography
                      variant="body2"
                      fontWeight={commonCss.mainLabelHeading}
                      color={commonCss.blue}
                    >
                      Permit validity (where work is going to last more than the
                      duration of a day)
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <Typography
                      variant="body2"
                      fontWeight={commonCss.normalSentenceWeight}
                      color={commonCss.normalSenternceColor}
                      sx={{ textTransform: "none" }}
                    >
                      Permit issuer & Permit Holder confirm by signing that the
                      precautions required to work safely have been complied
                      with prior to starting work each day or work period. At
                      the close of each day, the Permit Issuer & Permit Holder
                      sign to confirm that the area has been left in a safe
                      condition (although it is still not an operational area,
                      i.e. it has been handed back) and that all staff have left
                      the site.
                    </Typography>
                  </Grid2>
                  <Grid2
                    container
                    size={12}
                    alignItems={"center"}
                    spacing={"1rem"}
                  >
                    <Grid2 size={{ xs: 12, md: 3 }}>
                      <Button
                        variant="contained"
                        disabled={
                          roleAccess.oeController ||
                          PSData.filter((fil) => fil.isShiftClosed === false)
                            .length !== 0
                        }
                        sx={{
                          backgroundColor: commonCss.blue,
                          borderRadius: commonCss.buttonBorderRadius,
                          textTransform: "none",
                          padding: "0.6rem 1rem",
                          color: commonCss.buttonTextColor,
                          width: { xs: "50%", md: "15vw" },
                        }}
                        onClick={() => {
                          setConfirm({ ...confirm, shiftStart: true });
                          setConfirmValue([values, "start"]);
                        }}
                      >
                        Start Shift
                      </Button>
                    </Grid2>
                    <Grid2
                      size={{ xs: 12 }}
                      sx={{ display: PSData.length === 0 ? "none" : "default" }}
                    >
                      <Paper sx={{ background: "transparent" }}>
                        <NormalTableWithRadius
                          data={PSData}
                          columns={shiftColumns}
                        />
                      </Paper>
                    </Grid2>
                  </Grid2>
                </Grid2>

                <Grid2 container size={12} spacing={"1rem"}>
                  <Grid2 size={12}>
                    <Typography
                      variant="body2"
                      fontWeight={commonCss.mainLabelHeading}
                      color={commonCss.blue}
                    >
                      PERMIT CLOSE OUT
                    </Typography>
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Box sx={{ width: "100%" }}>
                      <Grid2 container size={12} spacing={"0.5rem"}>
                        <Grid2 size={12}>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.mainLabelHeading}
                            color="rgb(0, 86, 151)"
                          >
                            PERMIT HOLDER
                          </Typography>
                        </Grid2>
                        <Grid2 size={12}>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.normalSentenceWeight}
                            color={commonCss.normalSenternceColor}
                            sx={{ textTransform: "none" }}
                          >
                            Close Out – Work Completed
                          </Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Name
                            </Typography>
                          </InputLabel>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            value={holderName.phClose}
                            slotProps={{
                              input: {
                                readOnly: true,
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: commonCss.readOnlyBGColor,
                                borderRadius: commonCss.inputBorderRadius,
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: commonCss.inputBorderColor,
                              },
                            }}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Date/Time
                            </Typography>
                          </InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DateTimePicker
                                ampm={false}
                                format="DD/MM/YYYY HH:mm"
                                viewRenderers={{
                                  hours: renderTimeViewClock,
                                  minutes: renderTimeViewClock,
                                  seconds: renderTimeViewClock,
                                }}
                                readOnly
                                value={
                                  values.isPHPermitClosed
                                    ? dayjs(values.permitClosedByHolderAt)
                                    : null
                                }
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    variant: "outlined",
                                  },
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: commonCss.inputBorderRadius,
                                    backgroundColor: commonCss.readOnlyBGColor,
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: commonCss.inputBorderColor,
                                  },
                                }}
                                fullWidth
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Remark
                            </Typography>
                          </InputLabel>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            value={closeRemark.PH}
                            multiline
                            minRows={2}
                            slotProps={{
                              input: {
                                readOnly: roleAccess.phClose,
                              },
                            }}
                            onChange={(e) => {
                              setCloseRemark({
                                ...closeRemark,
                                PH: e.target.value,
                              });
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: roleAccess.phClose
                                  ? commonCss.readOnlyBGColor
                                  : commonCss.inputBackgroundColor,
                                borderRadius: commonCss.inputBorderRadius,
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: commonCss.inputBorderColor,
                              },
                            }}
                          />
                        </Grid2>
                        <Grid2
                          container
                          size={{ xs: 12 }}
                          justifyContent={"flex-start"}
                          sx={{
                            display: roleAccess.phClose ? "none" : "default",
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "rgb(0, 86, 151)",
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "15vw",
                            }}
                            onClick={() => {
                              setConfirm({ ...confirm, close: true });
                            }}
                          >
                            Close
                          </Button>
                        </Grid2>
                      </Grid2>
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Box sx={{ width: "100%" }}>
                      <Grid2 container size={12} spacing={"0.5rem"}>
                        <Grid2 size={12}>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.mainLabelHeading}
                            color="rgb(0, 86, 151)"
                          >
                            PERMIT ISSUER / LEAD PERMIT ISSUER
                          </Typography>
                        </Grid2>
                        <Grid2 size={12}>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.normalSentenceWeight}
                            color={commonCss.normalSenternceColor}
                            sx={{ textTransform: "none" }}
                          >
                            Signing Off – Accepting completion of the work
                          </Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Name
                            </Typography>
                          </InputLabel>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            value={holderName.lpiAndPiClose}
                            slotProps={{
                              input: {
                                readOnly: true,
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: commonCss.readOnlyBGColor,
                                borderRadius: commonCss.inputBorderRadius,
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: commonCss.inputBorderColor,
                              },
                            }}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Date/Time
                            </Typography>
                          </InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DateTimePicker
                                ampm={false}
                                format="DD/MM/YYYY HH:mm"
                                viewRenderers={{
                                  hours: renderTimeViewClock,
                                  minutes: renderTimeViewClock,
                                  seconds: renderTimeViewClock,
                                }}
                                readOnly
                                value={
                                  values.isLPIPermitClosed !== null
                                    ? dayjs(values.permitClosedByLPIAt)
                                    : values.isPIPermitClosed
                                      ? dayjs(values.permitClosedByPIAt)
                                      : null
                                }
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    variant: "outlined",
                                  },
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: commonCss.inputBorderRadius,
                                    backgroundColor: commonCss.readOnlyBGColor,
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: commonCss.inputBorderColor,
                                  },
                                }}
                                fullWidth
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Remark
                            </Typography>
                          </InputLabel>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            value={closeRemark.LPIPI}
                            multiline
                            minRows={2}
                            slotProps={{
                              input: {
                                readOnly: roleAccess.piAndLpoClose,
                              },
                            }}
                            onChange={(e) => {
                              setCloseRemark({
                                ...closeRemark,
                                LPIPI: e.target.value,
                              });
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: roleAccess.piAndLpoClose
                                  ? commonCss.readOnlyBGColor
                                  : commonCss.inputBackgroundColor,
                                borderRadius: commonCss.inputBorderRadius,
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: commonCss.inputBorderColor,
                              },
                            }}
                          />
                        </Grid2>
                        <Grid2
                          container
                          size={{ xs: 12 }}
                          justifyContent={"flex-start"}
                          sx={{
                            display: roleAccess.piAndLpoClose
                              ? "none"
                              : "default",
                          }}
                        >
                          <Button
                            // type={values.isLeadPermitIssuerApproved&&values.isPermitIssuerApproved?"submit":"button"}
                            variant="contained"
                            sx={{
                              backgroundColor: "rgb(0, 86, 151)",
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "15vw",
                            }}
                            onClick={() => {
                              setConfirm({ ...confirm, close: true });
                            }}
                          >
                            Close
                          </Button>
                        </Grid2>
                      </Grid2>
                    </Box>
                  </Grid2>
                </Grid2>
                <Grid2
                  container
                  size={12}
                  spacing={"1rem"}
                  justifyContent={"flex-end"}
                >
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                      onChangeTab("", "1");
                    }}
                    sx={{
                      backgroundColor: "rgb(0, 86, 151)",
                      borderRadius: commonCss.buttonBorderRadius,
                      textTransform: "none",
                      padding: "0.6rem 1rem",
                      color: commonCss.buttonTextColor,
                      width: { xs: "50%", md: "10vw" },
                    }}
                  >
                    <ArrowBack /> Previous
                  </Button>
                </Grid2>
              </Grid2>
              <Dialog
                // maxWidth={"lg"}
                open={remarkButton}
                onClose={() => {
                  setRemarkButton(false);
                }}
                maxWidth="md"
                fullWidth
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Remark
                    handleSubmitRemark={(e) => {
                      rejectApproval(e);
                    }}
                    handleCloseClick={() => {
                      setRemarkButton(false);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.shiftStop}
                onClose={() => {
                  setConfirm({ ...confirm, shiftStop: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handleShift(...confirmValue);
                    }}
                    name={"stop"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, shiftStop: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.reAssign}
                onClose={() => {
                  setConfirm({ ...confirm, reAssign: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handleReassign(...confirmValue);
                    }}
                    name={"reassign"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, reAssign: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.approve}
                onClose={() => {
                  setConfirm({ ...confirm, approve: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      onAcknowledge(...confirmValue);
                    }}
                    name={"approve"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, approve: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.shiftStart}
                onClose={() => {
                  setConfirm({ ...confirm, shiftStart: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handleShift(...confirmValue);
                    }}
                    name={"start"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, shiftStart: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.close}
                onClose={() => {
                  setConfirm({ ...confirm, close: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handlePermitClose();
                    }}
                    name={"close"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, close: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.precautionDel}
                onClose={() => {
                  setConfirm({ ...confirm, precautionDel: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handleDeletePrecaution([...confirmValue]);
                    }}
                    name={"close"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, precautionDel: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default PTWForm2;
